const MetaTrader5MobileContentFour = () => {
  return (
    <div className="how__work__platform">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="thumb-left">
              <div className="content-left">
                <h2>Multi-Asset Trading Made Simple</h2>

                <p>
                  Access global financial markets and manage diverse instruments
                  all from your mobile device.
                </p>
              </div>
              <img
                src={process.env.PUBLIC_URL + "/images/platforms/meta_trader_5_mobile/meta_trader_5_mobile_3.png"}
                alt="computer images"
              />
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="content-right">
              <h3>Forex</h3>
              <p>
                Trade major, minor, and exotic pairs with institutional-grade
                execution speeds and competitive spreads.
                {/* Conversely, rate cuts can weaken a
                currency as investors seek higher yields elsewhere. Traders
                closely follow central bank announcements and policy statements
                to anticipate shifts in monetary policy. */}
              </p>
              <hr className="black-line" />
              <h3> Commodities</h3>
              <p>
                Access global commodity markets, from energy and metals to
                agriculture, with advanced analytical tools and live data.
                {/* Stable inflation and strong
                performance usually strengthen a currency, while economic
                slowdown or uncertainty can cause depreciation. Traders monitor
                key indicators like CPI, PMI, and retail sales to identify
                potential trends in currency valuation. */}
              </p>
              <hr className="black-line" />
              <h3>Indices</h3>
              <p>
                Track and trade top-performing global indices with high
                precision and leverage opportunities.
                {/* In contrast, geopolitical
                tensions or unexpected global events can increase volatility as
                traders move toward safe-haven assets like the USD, CHF, or JPY. */}
              </p>
              <hr className="black-line" />
              <h3>Cryptocurrencies</h3>
              <p>
                Trade digital assets confidently with cutting-edge encryption
                and real-time liquidity from trusted sources.
                {/* Large institutional players and algorithmic trading
                systems can amplify these effects, making sentiment analysis a
                valuable tool for modern forex traders. */}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetaTrader5MobileContentFour;
